export const GaugeType = {
    MultiStepBooleanWaterDisplay: 'MultiStepBooleanWaterDisplay',
    StaticMeter: 'Meter Display',
    StaticMeterClassic: 'Meter Classic Display',
    StaticMeterColors: 'Meter Colors Display',
    StaticBoolean: 'Boolean Display',
    StaticNumber: 'Number Display',
    CountingNumber: 'Counting Number Display',
    StaticString: 'String Display',
    StaticBooleanWater: 'Boolean Water Display',
    NoDisplay: 'NoDisplay',

    // Deprecate
    Meter: 'Meter',
    BooleanDisplay: 'BooleanDisplay',
    NumberDisplay: 'NumberDisplay',
    StringDisplay: 'StringDisplay',
    BooleanWaterDisplay: 'BooleanWaterDisplay',

    // Readonly
    MultiStepBooleanDisplay: 'MultiStepBooleanDisplay',
    MultiStepNumberDisplay: 'MultiStepNumberDisplay',
}
